import { Box } from "@mui/material";
import DefaultText from "../../../../components/typography/default-text";
import styles from "./styles.module.css";

const Telecom = () => {

  return (
    <>
    <div className={styles["sub-page-content"]} style={{ backgroundColor: "var(--secondary-grey)" }}>
          <div className={styles["titulo-cards-container"]}>
            <div className={styles["title-wrapper"]}>
              <DefaultText 
                size="medium" 
                maxWidth={"min(430px, 90vw)"} 
              lineHeight="var(--font-size-large)" 
                className={styles["responsive-title"]}>
              Soluções para que <br/>
              <span className={styles["responsive-title-bold"]}>
                tudo fique conectado
              </span>
              </DefaultText>
            </div>
        <div className={styles["solutions-grid"]}>
          <div className={styles["solutions-card"]}>
            <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500, fontSize: "clamp(0.875rem, 1.5vw, 1.25rem)" }}>
            Survey para construção de redes <span className={styles["desktop-break"]}></span> ópticas.
            </DefaultText>
          </div>
          <div className={styles["solutions-card"]}>
            <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500, fontSize: "clamp(0.875rem, 1.5vw, 1.25rem)" }}>
            Elaboração de projetos de redes <span className={styles["desktop-break"]}></span> de ópticas.
        </DefaultText>
          </div>
          <div className={styles["solutions-card"]}>
            <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500, fontSize: "clamp(0.875rem, 1.5vw, 1.25rem)" }}>
            Construção de redes ópticas <span className={styles["desktop-break"]}></span> (Home Passed).
            </DefaultText>
          </div>
          <div className={styles["solutions-card"]}>
            <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500, fontSize: "clamp(0.875rem, 1.5vw, 1.25rem)" }}>
              Manutenção de redes ópticas <span className={styles["desktop-break"]}></span> (Backbone e Backhaul).
            </DefaultText>
          </div>
          <div className={styles["solutions-card"]}>
            <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500, fontSize: "clamp(0.875rem, 1.5vw, 1.25rem)" }}>
              Instalação (Home Connect) e <span className={styles["desktop-break"]}></span> manutenção de serviços de FTTH <span className={styles["desktop-break"]}></span> (VOIP, Banda Larga e IPTV) em <span className={styles["desktop-break"]}></span> redes ópticas.
            </DefaultText>
          </div>
          <div className={styles["solutions-card"]}>
            <DefaultText size="small" style={{ fontFamily: 'Montserrat-Regular', fontWeight: 500, fontSize: "clamp(0.875rem, 1.5vw, 1.25rem)" }}>
              Instalação e manutenção de <span className={styles["desktop-break"]}></span> circuitos de dados em redes <span className={styles["desktop-break"]}></span> ópticas.
            </DefaultText>
          </div>
        </div>
      </div>
      <div className={styles["text-content-row-wrap"]}>
          <Box display={"flex"} flexDirection={"column"} gap={"1rem"}>
            <DefaultText size="medium" lineHeight="var(--font-size-large)" className={styles["responsive-title"]}>
              Serviços de Inteligência <br/>
              <span className={styles["responsive-title-bold"]}>
                e Inovação
              </span>
            </DefaultText>
            <DefaultText size="small">
              <div className={styles["text-container-desktop"]}>
                Nossa equipe de especialistas em conectividade, <br/>
                energia e tecnologia da informação desenvolve <br/>
                projetos de inteligência com foco em soluções <br/>
                inovadoras.
              </div>
              <div className={styles["text-container-mobile"]}>
                Nossa equipe de especialistas <br/>
                em conectividade, energia e <br/>
                tecnologia da informação <br/>
                desenvolve projetos de <br/>
                inteligência com foco em <br/>
                soluções inovadoras.
              </div>
            </DefaultText>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={"1rem"}>
            <DefaultText size="medium" lineHeight="var(--font-size-large)"  className={styles["responsive-title"]}>
              Atender com eficiência os principais <span className={styles["desktop-break"]}></span>
              <span className={styles["responsive-title-bold"]}>
                provedores, distribuidoras de <span className={styles["desktop-break"]}></span> energia e operadoras do Brasil.
              </span>
            </DefaultText>
            <DefaultText size="small">
              <div className={styles["text-container-desktop"]}>
                Oferecemos soluções inteligentes e integradas <br/>
                em Telecom e Energia, com capilaridade <br/>
                nacional, para atender com alto padrão de <br/>
                qualidade as principais operadoras e <br/>
                concessionárias de energia do país.
              </div>
              <div className={styles["text-container-mobile"]}>
                Oferecemos soluções <br/>
                inteligentes e integradas em <br/>
                Telecom e Energia, com <br/>
                capilaridade nacional, para <br/>
                atender com alto padrão de <br/>
                qualidade as principais <br/>
                operadoras e concessionárias <br/>
                de energia do país.
              </div>
            </DefaultText>
          </Box>
        </div>
      </div>
    </>
  );
};

export default Telecom;
